module.exports = __webpack_public_path__ + "static/DJS0-ecbc1a438db6cac8a8cde44c41d8a687.png";